export default __webpack_public_path__ + "assets/illustrations/smile_emoji.d3597ca221b944131b212586dcc0d55c.png";